// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circle-container {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
}

.circle-half {
  position: absolute;
  width: 100%;
  height: 100%;
}

.circle-left {
  clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);
}

.circle-right {
  clip-path: polygon(50% 0, 100% 0, 100% 100%, 50% 100%);
}
`, "",{"version":3,"sources":["webpack://./src/teams/TeamColorsCircle.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,sDAAsD;AACxD","sourcesContent":[".circle-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  overflow: hidden;\n}\n\n.circle-half {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n\n.circle-left {\n  clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);\n}\n\n.circle-right {\n  clip-path: polygon(50% 0, 100% 0, 100% 100%, 50% 100%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
